/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportConnectDailymotionApiKeyMutationRequest, SocialExportConnectDailymotionApiKeyMutationResponse, SocialExportConnectDailymotionApiKey400 } from "../models/SocialExportConnectDailymotionApiKey";

export function getSocialExportConnectDailymotionApiKeyUrl() {
  const res = { method: 'POST', url: `/social-export/v1/auth/dailymotion/api-key` as const }
  return res
}

/**
 * @description Creates a client-owned Dailymotion connection using API key credentials instead of OAuth. Assign the connection to stations separately.
 * @summary Connect Dailymotion with a private API key
 * {@link /social-export/v1/auth/dailymotion/api-key}
 */
export async function socialExportConnectDailymotionApiKey(data: SocialExportConnectDailymotionApiKeyMutationRequest, config: Partial<RequestConfig<SocialExportConnectDailymotionApiKeyMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SocialExportConnectDailymotionApiKeyMutationResponse, ResponseErrorConfig<SocialExportConnectDailymotionApiKey400>, SocialExportConnectDailymotionApiKeyMutationRequest>({ method : "POST", url : getSocialExportConnectDailymotionApiKeyUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}